import { Button, Card, Form, Input, Select, Spin } from 'antd';
import React from "react";
import { sanitizeFieldName } from "../../util/methods";
import SubList from "../../components/PreVerificationEditSubList";
import './style.css';

let cnt = 0, payload = {};

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.qrCode = React.createRef();
    this.state = {
      loading: false,
      showQRCodeSection: 0,
      subData: [{}],
      documentData: [],
      formData: {},
      latitude: 0,
      longitude: 0,
      tempAssetCode: '',
      userName: '',
      checked: false,
      uploaded: false,
      uploadedCount: 0,
      tempAssets: [],
      assetDocumentData: [],
    };
  }

  componentDidMount = async () => {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }

    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.name) {
      this.setState({ username: user.name });
    }
    this.props.findAllPvNo();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({ subData: nextProps.data.assetDetails });
    }

    if (nextProps && nextProps.match && nextProps.match.params && JSON.stringify(nextProps.match.params.id) !== JSON.stringify(this.props.match.params.id)) {
      nextProps && nextProps.fetch && nextProps.fetch(nextProps.match.params.id);
    }
  }

  updateUploadedState = () => {
    this.setState({ uploaded: true });
  }

  onClick = () => {
    this.child.current.clearDocumentData();
    if (this.props.title === 'CREATE') {
      this.setState({ documentData: {} });
    }
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      this.props.onSubmit(values);
    });
  };

  getDocumentData = (data) => {
    //this.props.form.setFieldsValue({[`assetDetails[0][fileData]`]: data });
    this.setState({ documentData: data });
  };

  getAssetDocumentData = (data) => {
    //this.props.form.setFieldsValue({[`assetDetails[0][documents]`]: data });
    this.setState({ assetDocumentData: data });
  };

  componentWillUnmount() {
    if (this.props.title === 'CREATE') {
      this.props.clearData();
    }
    cnt = 0;
    payload = {};
  }


  handlePvSelect = (values) => {
    if (this.props.pvData && this.props.pvData.length) {
      for (let i = 0; i < this.props.pvData.length; i++) {
        let item = this.props.pvData[i];
        if (JSON.stringify(item._id) === JSON.stringify(values)) {
          this.setState({ tempAssets: item.assetDetails });
        }
      }
    }
  }

  render() {
    const { getFieldDecorator, setFieldsValue } = this.props.form;
    const { data, loading, filters, title, resource, subDocumentFilters, form, authUser, tempAssetCodeData } = this.props;
    return (
      <Spin spinning={this.state.loading || loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <div className={'asset-stock-taking'}>
              {
                this.props.title === 'VIEW' ? <Form.Item key={'approvalNumber'} label={'PV Approval No'}>
                  {getFieldDecorator(`pvAppNo`, {
                    initialValue: this.props.data && this.props.data['pvAppNo'],
                  })(<Input style={{ marginRight: 8, width: '75%' }} disabled={true}
                    placeholder={'Enter PV App Number'} />)
                  }
                </Form.Item> : <> </>
              }
              {
                this.props.title === 'VIEW' ? <Form.Item key={'createdBy'} label={'Submitted By'}>
                  {getFieldDecorator(`createdBy`, {
                    initialValue: this.props.data && this.props.data['createdBy'] && this.props.data['createdBy']['name'],
                  })(<Input style={{ marginRight: 8, width: '75%' }} disabled={true}
                    placeholder={'Enter User'} />)
                  }
                </Form.Item> : <> </>
              }


              <Form.Item key={'pvNo'}
                label={sanitizeFieldName(filters['pvNo'] && filters['pvNo'].options.label ? filters['pvNo'].options.label : 'pvNo')}>
                {getFieldDecorator('pvNo', {
                  rules: [{
                    required: true,
                    message: `${sanitizeFieldName(filters['pvNo'] && filters['pvNo'].options.label ? filters['pvNo'].options.label : 'pvNo')} is required!`
                  }],
                  initialValue: data && data['pvNo'] && data['pvNo'].pvNo,
                })(<Select
                  showSearch
                  placeholder="Please select PV"
                  style={{ marginRight: 8, width: '75%' }}
                  onSelect={this.handlePvSelect}
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                  disabled={(title === 'VIEW') || false}
                >
                  {this.props.pvData && this.props.pvData.length && this.props.pvData.filter(itm => itm.status === 'SUBMITTED' || itm.status === 'COMPLETED').map(itm =>
                    <Select.Option key={itm._id} value={itm._id}>{itm['pvNo']}</Select.Option>)}
                </Select>)}
              </Form.Item>
              {
                this.state.tempAssets && this.state.tempAssets.length ? this.state.tempAssets.map((tempAssetRecord, index) => {
                  return <SubList changeCountable={this.onChangeCountable} tempAssets={this.state.tempAssets}
                    ref={this.child} index={index} subDocumentFilters={subDocumentFilters}
                    match={this.props.match} history={this.props.history} pvData={this.props.pvData}
                    documentData={this.state.documentData} getDocumentData={this.getDocumentData}
                    checked={this.state.checked} key={tempAssetRecord.tempAssetCode}
                    filters={filters} item={filters['assetDetails']} field={tempAssetRecord}
                    updateDocumentData={this.getDocumentData} assetSubTypes={this.props.assetSubTypes}
                    assetModels={this.props.assetModels}
                    handleSelectAssetType={this.props.handleSelectAssetType}
                    handleSelectAssetSubType={this.props.handleSelectAssetSubType}
                    updateAssetDocumentData={this.getAssetDocumentData}
                    updateUploadedState={this.updateUploadedState}
                    form={this.props.form} data={[{}]} title={title} resource={resource} />
                }) : title === 'VIEW' && this.props.data && this.props.data.assetDetails && this.props.data.assetDetails.length ?
                  this.props.data.assetDetails.map((astd, index) => {
                    return <SubList changeCountable={this.onChangeCountable} tempAssets={this.props.data.assetDetails}
                      ref={this.child} subDocumentFilters={subDocumentFilters} index={index}
                      match={this.props.match} history={this.props.history} pvData={this.props.pvData}
                      documentData={this.state.documentData} getDocumentData={this.getDocumentData}
                      checked={this.state.checked} key={this.props.data.tempAssetCode}
                      filters={filters} item={filters['assetDetails']} field={astd}
                      updateDocumentData={this.getDocumentData} assetSubTypes={this.props.assetSubTypes}
                      assetModels={this.props.assetModels}
                      handleSelectAssetType={this.props.handleSelectAssetType}
                      handleSelectAssetSubType={this.props.handleSelectAssetSubType}
                      updateAssetDocumentData={this.getAssetDocumentData}
                      updateUploadedState={this.updateUploadedState}
                      form={this.props.form} data={[{}]} title={title} resource={resource} />
                  }) : <> </>
              }
            </div>
            {
              title !== 'VIEW' ? <Form.Item>
                <Button type="primary" htmlType="submit" className="gx-mb-0">
                  Save Report
                </Button>
              </Form.Item> : <> </>
            }
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
